import React from 'react'

const Wrapper = ({ children }) => {
    return (
        <div style={{ display: "grid", placeItems: "center", width: "2rem", height: "2rem", backgroundColor: "#02042D", borderRadius: "5px" }}>
            {children}
        </div>
    )
}

export default Wrapper;